import React from "react"
import "../Colors/Colors.css"

const ColourInput = props => (
  <div class={"filter-color" + " " + props.color}>
    <span className="tooltiptext">{props.color}</span>
  </div>
)

export default ColourInput
